let count = 0;

export function resetId(): void {
  count = 0;
}

export function getNextId(): string {
  const id = `element-id-${count}`;
  count += 1;
  return id;
}



// WEBPACK FOOTER //
// ../react-lib/src/utils/elementIdCreator.ts